import { render, staticRenderFns } from "./TeamMemberCard.vue?vue&type=template&id=71bdc220&scoped=true&"
import script from "./TeamMemberCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TeamMemberCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TeamMemberCard.vue?vue&type=style&index=0&id=71bdc220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdc220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71bdc220')) {
      api.createRecord('71bdc220', component.options)
    } else {
      api.reload('71bdc220', component.options)
    }
    module.hot.accept("./TeamMemberCard.vue?vue&type=template&id=71bdc220&scoped=true&", function () {
      api.rerender('71bdc220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/about-us/index/components/MainContent/components/TeamMemberCard.vue"
export default component.exports